import { USER_CUSTOMIZATIONS_REQUESTED,
    USER_CUSTOMIZATIONS_RECEIVED,
    USER_CUSTOMIZATIONS_ERROR,

    } from "../actions/userCustomizations";
import RequestState from "../storage/RequestState";
import RequestResult from "../storage/RequestResult";
import {EMPTY_REQUEST_RESULT_INIT_STATE} from "../utils/JsObjectHelper";

/**
*
* @param {RequestResult} state
* @param {BaseAction|ReceiveEntryTypesAction|ReceiveErrorAction} action
* @return {RequestResult}
*/
export const userCustomizations = (state = EMPTY_REQUEST_RESULT_INIT_STATE, action)  => {

switch (action.type) {
   case USER_CUSTOMIZATIONS_REQUESTED:
       return new RequestResult(RequestState.getInstanceLoading(), state.data);
   case USER_CUSTOMIZATIONS_RECEIVED:
       return new RequestResult(RequestState.getInstanceDone(), action.userCustomizations, action.receivedAt);
   case USER_CUSTOMIZATIONS_ERROR:
       return new RequestResult(
           RequestState.getInstanceError(
               action.errorResponseStatusCode,
               action.errorResponseMessage ? action.errorResponseMessage : null
           ),
           state.getData()
       );
 
   default:
       return state
}
};
